import { useCallback, useEffect, useRef, useState } from "react";
import getConnection from "core/shared/util/marvellConnection";
import ReportsConstants from "reports/utils/ReportsConstants";

const { ACTIVATE } = ReportsConstants;
const transformSending = ({ action, data }) => {
  const active = action === ACTIVATE;

  const reportsList = data.map(
    ({
      reportName,
      reportStatus,
      reportType,
      createdBy,
      organizationId,
      ...rest
    }) => {
      return { ...rest, active };
    }
  );

  return { reportsList };
};

const useDataExportUpdate = () => {
  const connection = getConnection();
  const abortControllerRef = useRef();
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState(null);

  const postData = useCallback(
    async ({ action, data }) => {
      const reportsList = transformSending({ action, data });
      abortControllerRef.current = new AbortController();
      const { signal } = abortControllerRef.current;
      setIsSending(true);

      try {
        const response = await connection.bulkUpdateDataExportReports({
          reportsList,
          signal,
        });
        setIsSending(false);
        return response;
      } catch (err) {
        setError(err);
        setIsSending(false);
        return null;
      }
    },
    [connection]
  );

  useEffect(() => {
    return () => {
      abortControllerRef.current?.abort();
    };
  }, []);

  return { isSending, error, postData };
};

export default useDataExportUpdate;
